// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import './font/iconfont.css'
import "./css/swiper.css"

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Mint from 'mint-ui';
import './css/mint-ui.css';
import common from './js/common.js';
import status from './js/status.js';
import 'jquery';
import ElementUI from 'element-ui'


Vue.use(Mint);
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
axios.defaults.baseURL = "";
axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.use(ElementUI);

//全局js函数和变量
Vue.prototype.$common = common;
Vue.prototype.$status = status

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  Vue.$indicator.open({
    spinnerType: "fading-circle"
  });

  if (sessionStorage.getItem("stripToken") != null && sessionStorage.getItem("stripUserId") != null && sessionStorage.getItem("stripTimeStamp") != null) {
    config.headers['token'] = sessionStorage.getItem("stripToken");
    config.headers['userId'] = sessionStorage.getItem("stripUserId");
    config.headers['timeStamp'] = sessionStorage.getItem("stripTimeStamp");
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  Vue.$indicator.open({
    spinnerType: "fading-circle"
  });
  return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  Vue.$indicator.close();
  if (response.status == "200" && response.data.status == "success"  ) {
    return response.data;
  }
  else {
    if (response.data.message != null && response.data.message != undefined && response.data.message != "") {
      Vue.$messagebox({
        title: "提示",
        message: response.data.message,
      });
    }
    throw new Error()
  }

}, function (error) {
  // 对响应错误做点什么
  Vue.$indicator.close();
  Vue.$messagebox({
    title: "提示",
    message: "网络请求失败",
  });
  return Promise.reject(error);
});


//路由守卫
router.beforeEach((to, from, next) => {

  if(to.path=="/NewContact"){
    next();
  }
  else if(to.path=="/NewSignature"){
    next();
  }
  else if(to.path=="/NewMainContact"){
    next();
  }
  else{
 // next();
 Vue.axios.all([Vue.axios.post("/api/tourist/Member/Check").then(res => {
  if (res.data != null)
    common.SetUserInfo(res.data);
}).catch(err => {

})]).then(res => {

  if ((common.userInfo == null) && to.path != '/') {
    sessionStorage.setItem("TripUrl", to.path);
    next({
      path: '/'
    })
    next();
  }
  else if(from.name==="Signature" && sessionStorage.getItem('Vue_ResolutionType')==null)
  {
    next();
  }
  else if (from.name === "Signature") {
    Mint.MessageBox({
      title: "提示",
      message: "你确定离开当前页面？",
      showCancelButton: true
    })
      .then(res => {
        if (res == "confirm") {
          next();
        }
        else {
          next(false)
        }
      });
  }
  else if (from.name === null && to.path === "/") {
    next();
  }
  else if (from.name != null && to.path === "/" && common.userInfo != null) {
    next(false)
  }
  else if (from.name === to.name) {
    next(false)
  }
  else {
    next();
  }
})
  }
 
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
  },
  methods: {
    LoginOut() {
      let _self = this;
      _self.$common.ClearCookie("TripTel");
      _self.$common.ClearCookie("TripTimeStamp");
      _self.$common.ClearCookie("TripToken");
      _self.$common.SetUserInfo(null);
      sessionStorage.removeItem("stripToken");
      sessionStorage.removeItem("stripUserId");
      sessionStorage.removeItem("stripTimeStamp");
      _self.$router.push("/");
    },
    SetSession(token, userId, timeStamp) {
      sessionStorage.setItem("stripToken", token);
      sessionStorage.setItem("stripUserId", userId);
      sessionStorage.setItem("stripTimeStamp", timeStamp);
    },
    GetWeekDay(week) {
      let weekStr = "";
      switch (week) {
        case "Monday":
          weekStr = "周一";
          break;
        case "Tuesday":
          weekStr = "周二";
          break;
        case "Wednesday":
          weekStr = "周三";
          break;
        case "Thursday":
          weekStr = "周四";
          break;
        case "Friday":
          weekStr = "周五";
          break;
        case "Saturday":
          weekStr = "周六";
          break;
        case "Sunday":
          weekStr = "周日";
          break;
      }

      return weekStr;
    },
    Show(Id) {
      let _self = this;
      Id = 'CDC82662-8FE3-4969-BDA9-0C58FC239597';
      let param = {
        Id: Id
      }
      _self.axios.post('/api/attachment/Attachment/Show', param).then(res => {
        return res;
      }).catch(err => {

      })
    }
  },
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js